// src/pages/Enseignants/Attendance/FiltersBar.jsx
import React from "react";

/** Petit switch accessible */
const Switch = ({ id, checked, onChange, label }) => (
  <label htmlFor={id} className="inline-flex items-center gap-2 select-none">
    <span className="text-sm">{label}</span>
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={!!checked}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition
      ${checked ? "bg-emerald-500" : "bg-slate-300 dark:bg-slate-700"}`}
      title={label}
    >
      <span
        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition
        ${checked ? "translate-x-6" : "translate-x-1"}`}
      />
    </button>
  </label>
);

const FiltersBar = ({
  loading,

  dojos,
  selectedDojo,
  onDojoChange,

  groups,
  filterGroup,
  onGroupChange,

  seasons,
  selectedSeason,
  onSeasonChange,

  statutInscription,
  onStatutChange,

  selectedDate,
  onDateChange,

  hideLicencieArret,
  onToggleHideLicencie,

  sortAssiduity,
  onToggleSortAssiduity,

  onDeleteAll, // optionnel (admin uniquement)
}) => {
  return (
    <div className="rounded-2xl ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white/80 dark:bg-slate-900/60 p-4">
      <div className="grid md:grid-cols-3 gap-3">
        {/* Colonne 1 */}
        <div className="space-y-2">
          {dojos?.length > 1 && (
            <select
              value={selectedDojo}
              onChange={(e) => onDojoChange?.(e.target.value)}
              className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2"
              disabled={loading}
            >
              <option value="">Tous les dojos</option>
              {dojos.map((d) => (
                <option key={d.id} value={String(d.id)}>{d.dojo_nom}</option>
              ))}
            </select>
          )}

          <select
            value={filterGroup}
            onChange={(e) => onGroupChange?.(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2"
            disabled={loading}
          >
            <option value="">Tous les groupes</option>
            {groups.map((g) => (
              <option key={g.id} value={g.nom}>{g.nom}</option>
            ))}
          </select>
        </div>

        {/* Colonne 2 */}
        <div className="space-y-2">
          <select
            value={selectedSeason}
            onChange={(e) => onSeasonChange?.(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2"
            disabled={loading}
          >
            {seasons.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>

          <select
            value={statutInscription}
            onChange={(e) => onStatutChange?.(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2"
            disabled={loading}
          >
            <option value="">Tous les statuts</option>
            <option value="Licencié">Licencié</option>
            <option value="Inscrit">Inscrit</option>
            <option value="Cours d'essai">Cours d’essai</option>
            <option value="Licencié - Arrêt">Licencié - Arrêt</option>
            <option value="Licencié Hors Club">Licencié Hors Club</option>
            <option value="Ancien Licencié">Ancien Licencié</option>
          </select>
        </div>

        {/* Colonne 3 */}
        <div className="space-y-2">
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => onDateChange?.(e.target.value)}
            className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2"
            disabled={loading}
          />

          <div className="flex items-center gap-4 flex-wrap">
            <Switch
              id="hideLicencie"
              checked={hideLicencieArret}
              onChange={onToggleHideLicencie}
              label="Masquer Licenciés-Arrêt"
            />
            <Switch
              id="sortAssiduity"
              checked={sortAssiduity}
              onChange={onToggleSortAssiduity}
              label="Trier par assiduité"
            />
          </div>
        </div>
      </div>

      {/* Danger zone */}
      {onDeleteAll && (
        <div className="mt-3 flex justify-center">
          <button
            type="button"
            onClick={onDeleteAll}
            className="inline-flex items-center gap-2 px-3 py-2 text-sm rounded-xl ring-1 ring-rose-300 bg-rose-50 text-rose-700 hover:bg-rose-100 dark:bg-rose-900/30 dark:text-rose-200 dark:ring-rose-700"
          >
            <span>Supprimer tous les appels</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default FiltersBar;
